"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _utils = require("@trs/utils");
var _config = require("@trs/config");
var _heading = require("../heading");
var _input = require("../input");
var _Banner = _interopRequireDefault(require("./Banner"));
var _Media = _interopRequireDefault(require("./Media"));
var _ColorPicker = _interopRequireDefault(require("./ColorPicker"));
var _helpers = require("./helpers");
var _StyledTemplate = require("./StyledTemplate.style");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Template = /*#__PURE__*/function (_React$PureComponent) {
  function Template(props) {
    var _this;
    _classCallCheck(this, Template);
    _this = _callSuper(this, Template, [props]);
    _defineProperty(_this, "onToggleText", function () {
      _this.setState(function (prevState) {
        return {
          isCollapsed: !prevState.isCollapsed
        };
      });
      var scrollIntoViewOptions = {
        behavior: 'smooth',
        block: 'start'
      };
      _this.templateRef.current.scrollIntoView(scrollIntoViewOptions);
    });
    _this.state = {
      isCollapsed: false
    };
    _this.templateRef = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  _inherits(Template, _React$PureComponent);
  return _createClass(Template, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        title = _this$props.title,
        initialText = _this$props.initialText,
        text = _this$props.text,
        onChangeText = _this$props.onChange,
        onChangeBanner = _this$props.onChangeBanner,
        onChangeMedia = _this$props.onChangeMedia,
        maxTextLength = _this$props.maxTextLength,
        recommendedMediaSizes = _this$props.recommendedMediaSizes,
        banner = _this$props.banner,
        bannerMediaTypes = _this$props.bannerMediaTypes,
        media = _this$props.media,
        disabled = _this$props.disabled,
        readOnly = _this$props.readOnly,
        labels = _this$props.labels,
        images = _this$props.images,
        className = _this$props.className,
        childContainer = _this$props.childContainer,
        videoPlatformAccepted = _this$props.videoPlatformAccepted,
        error = _this$props.error,
        bannerError = _this$props.bannerError;
      var isCollapsed = this.state.isCollapsed;
      var hasError = !(0, _utils.isBlank)(error) || !(0, _utils.isBlank)(bannerError);
      var collapsableText = disabled && _utils.isMobile && text.length > _helpers.MOBILE_TEXT_LENGTH;
      var textValue = collapsableText && !isCollapsed ? "".concat((0, _utils.shortenText)(text, _helpers.MOBILE_TEXT_LENGTH), "...") : text;
      return /*#__PURE__*/_react["default"].createElement(_StyledTemplate.StyledTemplate, {
        className: className,
        hasError: hasError,
        readOnly: readOnly
      }, title && /*#__PURE__*/_react["default"].createElement("div", {
        className: "title"
      }, /*#__PURE__*/_react["default"].createElement(_heading.H3, null, title)), /*#__PURE__*/_react["default"].createElement(_Banner["default"], _extends({}, banner, {
        readOnly: readOnly,
        onChange: onChangeBanner,
        supportedMediaTypes: bannerMediaTypes,
        disabled: disabled,
        labels: labels,
        recommendedMediaSizes: recommendedMediaSizes,
        images: images,
        videoPlatformAccepted: videoPlatformAccepted,
        error: bannerError
      })), /*#__PURE__*/_react["default"].createElement(_StyledTemplate.StyledContent, null, /*#__PURE__*/_react["default"].createElement(_StyledTemplate.StyledContentItem, {
        ref: this.templateRef
      }, /*#__PURE__*/_react["default"].createElement(_input.RichTextarea, {
        toolbarHidden: readOnly,
        initialValue: initialText,
        value: textValue,
        collapsableText: collapsableText,
        expanded: isCollapsed,
        onToggleText: this.onToggleText,
        toolbar: {
          options: ['fontSize', 'colorPicker'],
          fontSize: {
            options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48]
          },
          colorPicker: {
            component: _ColorPicker["default"]
          },
          image: {
            previewImage: false
          }
        },
        childContainer: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, childContainer, /*#__PURE__*/_react["default"].createElement(_Media["default"], {
          readOnly: readOnly,
          data: media,
          isDescriptionEmpty: R.isEmpty(text),
          onChange: onChangeMedia,
          disabled: disabled,
          labels: labels,
          recommendedMediaSizes: recommendedMediaSizes,
          images: images,
          videoPlatformAccepted: videoPlatformAccepted
        })),
        onChange: function onChange(markup, plainText) {
          onChangeText('description', markup);
          onChangeText('plainText', plainText);
        },
        placeholder: labels.TEXT_PLACEHOLDER,
        maxLength: maxTextLength,
        disabled: disabled,
        ariaDescribedBy: "rewardDescription",
        error: error
      }))));
    }
  }]);
}(_react["default"].PureComponent);
Template.defaultProps = {
  readOnly: false,
  disabled: false,
  title: '',
  initialText: null,
  text: '',
  banner: {},
  media: [],
  onChange: function onChange() {},
  onChangeBanner: function onChangeBanner() {},
  onChangeMedia: function onChangeMedia() {},
  labels: {},
  images: {},
  maxTextLength: 100,
  recommendedMediaSizes: {},
  childContainer: null,
  videoPlatformAccepted: [],
  bannerMediaTypes: _config.MEDIA_TYPE,
  className: null,
  error: null,
  bannerError: null
};
Template.propTypes = {
  readOnly: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  title: _propTypes["default"].string,
  initialText: _propTypes["default"].string,
  text: _propTypes["default"].string,
  banner: _propTypes["default"].shape({
    src: _propTypes["default"].string,
    alt: _propTypes["default"].string,
    order: _propTypes["default"].number
  }),
  bannerMediaTypes: _propTypes["default"].shape({}),
  media: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    src: _propTypes["default"].string,
    alt: _propTypes["default"].string
  })),
  onChange: _propTypes["default"].func,
  onChangeBanner: _propTypes["default"].func,
  onChangeMedia: _propTypes["default"].func,
  maxTextLength: _propTypes["default"].number,
  labels: _propTypes["default"].shape({
    TEXT_PLACEHOLDER: _propTypes["default"].string
  }),
  recommendedMediaSizes: _propTypes["default"].shape({}),
  images: _propTypes["default"].shape({}),
  className: _propTypes["default"].string,
  childContainer: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].node]),
  error: _propTypes["default"].string,
  bannerError: _propTypes["default"].string,
  videoPlatformAccepted: _propTypes["default"].arrayOf(_propTypes["default"].string)
};
var _default = exports["default"] = Template;